const DIRECT_TRANSACTION_METADATA_KEY = `__tanstack_db_direct`;
export {
  DIRECT_TRANSACTION_METADATA_KEY
};
//# sourceMappingURL=transaction-metadata.js.map
